import axios from "../../axios/axios-api";
import axiosRoot from "../../axios/axios-root";

export const buscaCnsInternacao = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("setErrorCns", null)

    let token = rootGetters['sessao/getUsuario'].tokenAcesso

    let config = {
        headers: { Authorization: "Bearer " + token },
        params: {
            tipoDocumento: payload.tpDocumento,
            numeroDocumento: payload.documento,
            'g-recaptcha-response': payload.captcha
        }
    }
    
    return axiosRoot
    .get("publico/controller/consultarCADWEB.php", config)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit ("setErrorCns", resp.data.msg)
        if (resp.data.status == true){
            commit("setErrorCns", null)
            commit("setCnsInternacao", resp.data)
        } 
    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });


};


export const pegaListaProcedimentos = ({ commit }) => {

    return axiosRoot
    .get("publico/controller/listarSIGTAP.php")
    .then(resp => {
        commit("setListaProcedimentos", resp.data.dados)
    })
    .catch(error => {
        console.log(error)
    });
}

export const pegaListaCid = ({ commit }) => {

    return axiosRoot
    .get("publico/controller/listarCID.php")
    .then(resp => {
        commit("setListaCid", resp.data.dados)
    })
    .catch(error => {
        console.log(error)
    });
}


export const buscaConsolidado = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso

    let config = {
        headers: { Authorization: "Bearer " + token },
        params: {
          cnes: payload
        }
    }
    
    return axios
    .get("/api/censo/listarConsolidado", config)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("setConsolidado", resp.data.dados)

    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });

};
